import { type Types } from '@fiverr-private/theme';
import type { ModalSize } from '../types';

export const DIALOG_WIDTH: { [key in ModalSize]: Types.ResponsiveWidthType } = {
    sm: 520,
    md: 600,
    lg: 720,
    xl: 900,
    xxl: 1060,
};

export const MODAL_SIZES = { sm: 'sm', md: 'md', lg: 'lg', xl: 'xl', xxl: 'xxl' };

export const fullWidthProps: Types.FlexLayoutProps = {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    borderRadius: 'none',
    maxHeight: 'unset',
    maxWidth: '100%',
    width: '100%',
};
